<template>
  <div v-if="video" id="video-single">
    <section class="video-signle-container">
      <BaseVideoPlayer :youtube-link="video.youtubeLink" :thumb="video.mediaUrl" />
      <div class="video-single-description">
        <div class="video-single-description__inner">
          <div class="video-single-description__inner__buttons">
            <Label :position="true" name="video" />
            <ShareButton :position="true" />
          </div>
          <div class="video-single-description__inner__info">
            <div class="video-single-description__inner__date">
              {{ video.datetransmitted }} — {{ video.locationModel.locationname }}
            </div>
            <div class="video-single-description__inner__artist-heading">
              <router-link
                :to="{ name: artistTypeToRouteName, params: { id: video.mainArtist.permlink } }"
              >
                {{ getMainPodcastObject ? getMainPodcastObject.name : video.mainArtist.name }}
              </router-link>
              <template v-if="video.artists.length > 0">
                <span>feat. </span>
                <router-link
                  v-for="guest in artistListTypeToRouteName"
                  :key="guest.id"
                  :to="{ name: guest.route, params: { id: guest.permlink } }"
                >
                  {{ guest.name }}
                </router-link>
              </template>
            </div>
            <div class="video-single-description__inner__title-heading">
              {{ video.title }}
            </div>
            <div class="video-single-description__inner__credits">
              <div class="credit">
                <span>with {{ video.mainArtist.artistType }} host</span>
                <span><router-link
                  :to="{ name: artistTypeToRouteName, params: { id: video.mainArtist.permlink } }"
                >{{ video.mainArtist.name }}</router-link></span>
              </div>
              <div v-if="getMainPodcastObject" class="credit">
                <span>host on show</span><span><router-link
                  :to="{
                    name: 'Podcasts',
                    params: { id: getMainPodcastObject.permlink }
                  }"
                >{{ getMainPodcastObject.name }}</router-link></span>
              </div>
            </div>
            <div class="video-single-description__inner__text">
              <h5>VIDEO DESCRIPTION</h5>
              <div class="description" v-html="video.info" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import axios from 'axios';
import BaseVideoPlayer from '@/components/BaseVideoPlayer';
import Label from '@/components/Label.vue';
import ShareButton from '@/components/ui/ShareButton.vue';
export default {
  name: 'VideoSingle',
  components: {
    BaseVideoPlayer,
    Label,
    ShareButton
  },
  data: () => ({
    video: null
  }),

  computed: {
    formatArtistHeading() {
      if (this.video.artists.length > 0) {
        const title =
          this.video.mainArtist.name + ' feat. ' + this.video.artists.map(e => e.name).join(', ');
        return title;
      } else {
        return this.video.mainArtist.name;
      }
    },

    artistTypeToRouteName() {
      return this.video.mainArtist.artistType == 'Resident' ? 'Artist' : 'Guest';
    },

    artistListTypeToRouteName() {
      return this.video.artists.map(e => ({
        ...e,
        route: e.artistType == 'Resident' ? 'Artist' : 'Guest'
      }));
    },

    getMainPodcastObject() {
      if (this.video.mainArtist.mainPodcast) {
        return this.video.mainArtist.podcasts.find(e => e.id == this.video.mainArtist.mainPodcast);
      } else {
        return null;
      }
    }
  },

  mounted() {
    this.getVideoSignle();
  },

  methods: {
    getVideoSignle() {
      axios
        .get(this.$router.options.api + '/video/perm/' + this.$route.params.id)
        .then(response => {
          this.video = response.data;
        })
        .catch(error => console.error(error));
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/pages/_video-signle.scss';
</style>
